import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const createBrand = async (formValues) => {
  const formData = new FormData();
  formData.append("BrandName", formValues.BrandName);
  formData.append("BrandURL", formValues.BrandURL);
  formData.append("PageTitle", formValues.PageTitle || "");
  formData.append("MetaDescription", formValues.MetaDescription || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("Featured", formValues.Featured.toString());
  formData.append("DisplayOrder", formValues.DisplayOrder.toString());
  formData.append("FullDescription", formValues.FullDescription);
  formData.append("ShortDescription", formValues.ShortDescription);

  if (formValues.ImageURLFile) {
    formData.append("ImageURLFile", formValues.ImageURLFile);
  }
  const response = await axiosInstance.post("product/brand", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};
export const updateBrand = async (formValues) => {
  const formData = new FormData();
  formData.append("Id", formValues.Id);
  formData.append("BrandName", formValues.BrandName);
  formData.append("BrandURL", formValues.BrandURL);
  formData.append("PageTitle", formValues.PageTitle || "");
  formData.append("MetaDescription", formValues.MetaDescription || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("Featured", formValues.Featured.toString());
  formData.append("DisplayOrder", formValues.DisplayOrder.toString());
  formData.append("FullDescription", formValues.FullDescription);
  formData.append("ShortDescription", formValues.ShortDescription);

  if (formValues.ImageURLFile) {
    formData.append("ImageURLFile", formValues.ImageURLFile);
  } else {
    formData.append("ImageURLFile", null);
  }
  const response = await axiosInstance.put("product/brand", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};

export const fetchBrands = async () => {
  const response = await axiosInstance.get("product/brand", { headers });
  return response.data;
};

export const fetchBrandsForReOrder = async () => {
  const response = await axiosInstance.get("product/brand/for-re-order", {
    headers,
  });
  return response.data;
};

export const fetchBrandDropdowns = async () => {
  const response = await axiosInstance.get("product/brand/dropdown", {
    headers,
  });
  return response.data;
};

export const fetchBrandById = async (id) => {
  const response = await axiosInstance.get(`product/brand/${id}`, {
    headers,
  });
  return response.data;
};

export const publishBrand = async (id) => {
  return await await axiosInstance.patch(`product/brand/${id}/publish`, {
    headers,
  });
};

export const unPublishBrand = async (id) => {
  return await await axiosInstance.patch(`product/brand/${id}/unpublish`, {
    headers,
  });
};

export const markBrandFeatured = async (id) => {
  return await await axiosInstance.patch(`product/brand/${id}/featured`, {
    headers,
  });
};

export const markBrandUnFeatured = async (id) => {
  return await await axiosInstance.patch(`product/brand/${id}/unfeatured`, {
    headers,
  });
};

export const updateGalleryOrderService = async (orderData) => {
  const response = await axiosInstance.patch(
    `/product/brand/update-order`,
    orderData,
    {
      headers,
    }
  );
  return response.data;
};

export const deleteBrand = async (id) => {
  return await axiosInstance.delete(`product/brand/${id}`, { headers });
};
